import produce from 'immer';
import {
  GET_EAV_ATTRIBUTE_START,
  GET_EAV_ATTRIBUTE_SUCCESS,
  GET_EAV_ATTRIBUTE_FAILED,
  ADD_EAV_ATTRIBUTE_START,
  ADD_EAV_ATTRIBUTE_SUCCESS,
  ADD_EAV_ATTRIBUTE_FAILED,
  UPDATE_EAV_ATTRIBUTE_START,
  UPDATE_EAV_ATTRIBUTE_SUCCESS,
  UPDATE_EAV_ATTRIBUTE_FAILED,
  DELETE_EAV_ATTRIBUTE_START,
  DELETE_EAV_ATTRIBUTE_SUCCESS,
  DELETE_EAV_ATTRIBUTE_FAILED,
  GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_START,
  GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_SUCCESS,
  GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_FAILED,
} from '../actions/eavAttributes';

import {
  CHANGE_ACTIVE_STORE_SUCCESS
} from '../actions/user';


const initialState = {
  options: [],
  isEavAttributeLoading: false,
};

const formReducer = produce((state: IEavAttributesState = initialState, action) => {
  switch (action.type) {
    case GET_EAV_ATTRIBUTE_START: {
      state.isEavAttributeLoading = true;
      break;
    }
    case GET_EAV_ATTRIBUTE_SUCCESS: {
      const { data } = action;

      state.options = data.attribute.options?.filter((option) => !!option.value.length);
      state.isEavAttributeLoading = false;
      break;
    }
    case GET_EAV_ATTRIBUTE_FAILED: {
      state.isEavAttributeLoading = false;
      break;
    }

    case ADD_EAV_ATTRIBUTE_START: {
      state.isEavAttributeLoading = true;
      break;
    }
    case ADD_EAV_ATTRIBUTE_SUCCESS: {
      const { isAdded: addedOption } = action.data;

      state.options = [...state.options, {...addedOption, value: addedOption.value.toString()}];
      state.isEavAttributeLoading = false;
      break;
    }
    case ADD_EAV_ATTRIBUTE_FAILED: {
      state.isEavAttributeLoading = false;
      break;
    }

    case UPDATE_EAV_ATTRIBUTE_START: {
      state.isEavAttributeLoading = true;
      break;
    }
    case UPDATE_EAV_ATTRIBUTE_SUCCESS: {
      const {isAdded: updatedOption} = action.data;
      state.options = state.options.map((option) => option.value.toString() === updatedOption.value.toString() ? updatedOption : option);
      state.isEavAttributeLoading = false;
      break;
    }
    case UPDATE_EAV_ATTRIBUTE_FAILED: {
      state.isEavAttributeLoading = false;
      break;
    }

    case DELETE_EAV_ATTRIBUTE_START: {
      state.isEavAttributeLoading = true;
      break;
    }
    case DELETE_EAV_ATTRIBUTE_SUCCESS: {
      const { id } = action;

      state.options = state.options.filter((o) => o.value != id);
      state.isEavAttributeLoading = false;
      break;
    }
    case DELETE_EAV_ATTRIBUTE_FAILED: {
      state.isEavAttributeLoading = false;
      break;
    }

    case GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_START: {
      state.isEavAttributeLoading = true;
      break;
    }
    case GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_SUCCESS: {
      const { data } = action;

      const marketingSegmentMap = data.reduce((acc, entry) => {
        acc[entry.marketingSegment.value] = entry.customerData.total_count;
        return acc;
      }, {});

      const updatedOptions = state.options.map((option) => ({
        ...option,
        total_count: marketingSegmentMap[option.value] || 0,
      }));

      state.options = updatedOptions;
      state.isEavAttributeLoading = false;
      break;
    }
    case GET_QUOTE_CUSTOMERS_COUNT_BY_MARKETING_SEGMENT_FAILED: {
      state.isEavAttributeLoading = false;
      break;
    }

    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.options = initialState.options;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
